<template>
    <TeamTabs :selected-team="selectedTeam" tab-key="team-ai-usage">
        <div class="mb-[300px] mt-12 space-y-5">
            <div>
                <h1 class="text-xl font-semibold text-gray-800">
                    {{ selectedTeam.name }} — {{ t("vue.kiosk_ai_usage") }}
                </h1>
                <p class="text-sm text-gray-500">
                    {{ t("vue.kiosk_ai_usage_team_description") }}
                </p>
            </div>

            <AiUsageRangePicker
                :range="range"
                route-name="kiosk.teams.ai-usage.index"
                :route-params="{ team: selectedTeam.id }"
            />

            <AiUsageMetricCards :metrics="totals" />

            <AiUsageBreakdownTable
                :rows="rows"
                :title="t('vue.kiosk_ai_usage_by_member')"
                :entity-label="t('vue.kiosk_ai_usage_member')"
                detail-route-name="kiosk.users.ai-usage.index"
                detail-route-param="user"
            />
        </div>
    </TeamTabs>
</template>

<script lang="ts" setup>
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import { useTranslations } from "@/composables/useTranslations";
import AiUsageRangePicker from "../../AiUsage/components/AiUsageRangePicker.vue";
import AiUsageMetricCards from "../../AiUsage/components/AiUsageMetricCards.vue";
import AiUsageBreakdownTable from "../../AiUsage/components/AiUsageBreakdownTable.vue";
import type {
    IAiUsageMetrics,
    IAiUsageRange,
    IAiUsageRow,
} from "../../AiUsage/types";

defineProps<{
    selectedTeam: ICurrentTeam;
    range: IAiUsageRange;
    totals: IAiUsageMetrics;
    rows: IAiUsageRow[];
    breakdown: string;
}>();

const { t } = useTranslations();
</script>
